/* Account-menu popover controller. Wires up open/close behavior for any
   element marked `data-lb-account-menu` (which contains a single
   `.lb-account-menu__chip` button and a `.lb-account-menu__popover`).
   Reusable for the dashboard's bespoke header chip too — call
   attachAccountMenu(el) on a manually-constructed DOM tree. */

import {flipPopoverHorizontally} from './popover';

export function attachAccountMenu(root: HTMLElement): void {
	const chip = root.querySelector<HTMLButtonElement>('.lb-account-menu__chip');
	if (!chip) {
		return;
	}

	const positionPopover = (): void => {
		const popover = root.querySelector<HTMLElement>('.lb-account-menu__popover');
		if (!popover) {
			return;
		}
		flipPopoverHorizontally(popover, 'lb-account-menu__popover--align-left');
	};

	const open = (): void => {
		root.classList.add('lb-account-menu--open');
		chip.setAttribute('aria-expanded', 'true');
		// Position-correct on next frame, once the popover is laid out.
		window.requestAnimationFrame(positionPopover);
		document.addEventListener('mousedown', onOutside, true);
		document.addEventListener('keydown', onKey, true);
		window.addEventListener('resize', positionPopover);
	};

	const close = (): void => {
		root.classList.remove('lb-account-menu--open');
		chip.setAttribute('aria-expanded', 'false');
		document.removeEventListener('mousedown', onOutside, true);
		document.removeEventListener('keydown', onKey, true);
		window.removeEventListener('resize', positionPopover);
	};

	const onOutside = (evt: MouseEvent): void => {
		const target = evt.target as Node | null;
		if (target && !root.contains(target)) {
			close();
		}
	};

	const onKey = (evt: KeyboardEvent): void => {
		if (evt.key === 'Escape') {
			evt.preventDefault();
			close();
			chip.focus();
		}
	};

	chip.addEventListener('click', (evt: MouseEvent) => {
		evt.preventDefault();
		if (root.classList.contains('lb-account-menu--open')) {
			close();
		} else {
			open();
		}
	});
}

export function attachAllAccountMenus(): void {
	Array.from(document.querySelectorAll<HTMLElement>('[data-lb-account-menu]')).forEach(attachAccountMenu);
}
